import React, { useEffect, useState, useMemo } from "react";

import { useNavigate } from "react-router-dom";

import {
    Button,
    Table,
    Modal,
    Form,
    Input,
    InputNumber,
    Typography,
    App,
    Space,
    Select,
    Breadcrumb,
    theme,
    Card,
    Tag,
    Row,
    Col
} from "antd";

import {
    SearchOutlined,
    GiftOutlined
} from "@ant-design/icons";

import { useAuth } from "../../context/AuthProvider";

import ForbiddenPage from "../Status/ForbiddenPage";

import { getBackendUrl } from "../../utils/env";

import axios from "axios";

import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";

import "dayjs/locale/es";

dayjs.extend(relativeTime);
dayjs.locale("es");

const { Title, Text } = Typography;
const { Option } = Select;

export default function AdminBravosDashboard() {

    const { message } = App.useApp();
    const { user } = useAuth();
    const { token } = theme.useToken();

    const [usuarios, setUsuarios] = useState([]);
    const [loading, setLoading] = useState(false);

    const [modalVisible, setModalVisible] = useState(false);
    const [editingUser, setEditingUser] = useState(null);

    const [form] = Form.useForm();

    const navigate = useNavigate();

    const [searchText, setSearchText] = useState("");
    const [selectedGender, setSelectedGender] = useState(null);

    const [previewVisible, setPreviewVisible] = useState(false);
    const [previewImage, setPreviewImage] = useState("");

    // ============================================================
    // BONIFICACIONES
    // ============================================================

    const [selectedRowKeys, setSelectedRowKeys] = useState([]);

    const [bonusModalVisible, setBonusModalVisible] = useState(false);

    const [bonusLoading, setBonusLoading] = useState(false);

    const [bonusForm] = Form.useForm();

    // ============================================================
    // FILTRADO
    // ============================================================

    const filteredUsuarios = useMemo(() => {

        return usuarios.filter((u) => {

            const fullName =
                `${u.name} ${u.ape_pat} ${u.ape_mat} ${u.dinamica}`
                    .toLowerCase();

            const matchesText =
                fullName.includes(searchText.toLowerCase());

            const matchesGender =
                selectedGender
                    ? u.gender === selectedGender
                    : true;

            return matchesText && matchesGender;

        });

    }, [searchText, selectedGender, usuarios]);

    // ============================================================
    // GENEROS
    // ============================================================

    const genderOptions = useMemo(() => {

        const unique = [
            ...new Set(
                usuarios.map((u) => u.gender)
            )
        ];

        return unique.filter(Boolean);

    }, [usuarios]);

    // ============================================================
    // CARGAR USUARIOS
    // ============================================================

    useEffect(() => {

        if (user?.id === 1) {
            fetchUsuarios();
        }

    }, [user]);

    const fetchUsuarios = async () => {

        setLoading(true);

        try {

            const { data } = await axios.get(
                `${getBackendUrl()}api/admin/users.php`
            );

            if (data.success) {

                setUsuarios(data.users);

            } else {

                message.error(
                    "No se pudieron cargar los usuarios"
                );

            }

        } catch (error) {

            console.error(error);

            message.error(
                "Error al cargar los usuarios"
            );

        } finally {

            setLoading(false);

        }

    };

    // ============================================================
    // ACCIONES GENERALES
    // ============================================================

    
    // ============================================================
    // ACTIVAR / DESACTIVAR USUARIO
    // ============================================================

   



    // ============================================================
    // GUARDAR USUARIO
    // ============================================================

    const handleModalSubmit = async () => {

        try {

            const values =
                await form.validateFields();

            const payload = {

                ...values,

                sacraments:
                    values.sacraments.join(",")

            };

            const { data } = await axios.post(

                `${getBackendUrl()}api/admin/users.php?id=${editingUser.id}`,

                payload,

                {
                    headers: {
                        "Content-Type": "application/json"
                    }
                }

            );

            if (data.success) {

                message.success(
                    "Usuario actualizado"
                );

                setModalVisible(false);

                fetchUsuarios();

            } else {

                message.error(
                    "Error al actualizar usuario"
                );

            }

        } catch (error) {

            console.error(error);

            message.error(
                "Error al actualizar usuario"
            );

        }

    };

    // ============================================================
    // SELECCIÓN DE USUARIOS
    // ============================================================

    const rowSelection = {

        selectedRowKeys,

        onChange: (newSelectedRowKeys) => {

            setSelectedRowKeys(
                newSelectedRowKeys
            );

        },

    };

    // ============================================================
    // ABRIR MODAL DE BONIFICACIÓN
    // ============================================================

    const openBonusModal = () => {

        if (selectedRowKeys.length === 0) {

            message.warning(
                "Selecciona al menos un usuario"
            );

            return;

        }

        bonusForm.resetFields();

        setBonusModalVisible(true);

    };

    // ============================================================
    // APLICAR BONIFICACIÓN
    // ============================================================

    const handleBonusSubmit = async () => {

        try {

            const values =
                await bonusForm.validateFields();

            if (selectedRowKeys.length === 0) {

                message.warning(
                    "No hay usuarios seleccionados"
                );

                return;

            }

            setBonusLoading(true);

            const { data } = await axios.post(
                `${getBackendUrl()}api/admin/bonus.php`,
                {
                    user_ids: selectedRowKeys,
                    points: values.points,
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );

            if (data.success) {

                message.success(
                    `Se otorgaron ${values.points} Bravos a ${selectedRowKeys.length} usuario(s)`
                );

                setBonusModalVisible(false);

                setSelectedRowKeys([]);

                bonusForm.resetFields();

                fetchUsuarios();

            } else {

                message.error(
                    data.message ||
                    "No se pudo aplicar la bonificación"
                );

            }

        } catch (error) {

            console.error("ERROR BONUS:", error);

            console.log(
                "STATUS:",
                error.response?.status
            );

            console.log(
                "RESPUESTA BACKEND:",
                error.response?.data
            );

            console.log(
                "URL:",
                error.config?.url
            );

            message.error(
                error.response?.data?.message ||
                "Error al aplicar la bonificación"
            );

        } finally {

            setBonusLoading(false);

        }
    };

    // ============================================================
    // COLUMNAS
    // ============================================================

    const columns = [



        {
            title: "Nombre",
            key: "name",

            render: (_, record) => (

                <Space orientation="vertical" size={0}>

                    <Text strong>
                        {record.name} {record.ape_pat}
                    </Text>

                    <Text type="secondary">
                        {record.ape_mat}
                    </Text>

                </Space>

            )

        },

        {
            title: "Dinámica",
            dataIndex: "dinamica",
            key: "dinamica"
        },

        {
            title: "Género",
            dataIndex: "gender",
            key: "gender",

            render: (gender) => (

                gender ? (
                    <Tag>
                        {gender}
                    </Tag>
                ) : (
                    "-"
                )

            )

        },

        {
            title: "Bravos",
            dataIndex: "points",
            key: "points",

            render: (points) => (

                <Tag color="gold">
                    ⭐ {Number(points || 0).toLocaleString()}
                </Tag>

            )

        },



    ];

    // ============================================================
    // SEGURIDAD
    // ============================================================

    if (user?.id !== 1) {
        return <ForbiddenPage />;
    }

    // ============================================================
    // RENDER
    // ============================================================

    return (

        <div
            style={{
                padding: 'clamp(16px, 4vw, 32px)',
                maxWidth: 1400, // Un poco más ancho para tablas complejas
                margin: '0 auto',
                backgroundColor: token.colorBgLayout, // Fondo sutil para que el Card resalte
                minHeight: '100vh'
            }}
        >

            <Breadcrumb
                style={{ marginBottom: 16 }}
                items={[
                    { title: <a onClick={() => navigate("/admin")}>Panel de Administración</a> },
                    { title: "Gestión de Bonificaciones de Bravos" },
                ]}
            />


            {/* ======================================================
          HEADER
      ====================================================== */}

            <Row
                justify="space-between"
                align="middle"
                style={{
                    marginBottom: 24
                }}
            >

                <Col>

                    <Title
                        level={2}
                        style={{
                            margin: 0
                        }}
                    >
                        Usuarios
                    </Title>

                    <Text type="secondary">
                        Administración de Bravos
                    </Text>

                </Col>

                <Col>

                    <Button
                        type="primary"
                        icon={<GiftOutlined />}
                        disabled={
                            selectedRowKeys.length === 0
                        }
                        onClick={openBonusModal}
                    >
                        Otorgar Bravos
                        {selectedRowKeys.length > 0 &&
                            ` (${selectedRowKeys.length})`
                        }
                    </Button>

                </Col>

            </Row>

            {/* ======================================================
          FILTROS
      ====================================================== */}

            <Card
                style={{
                    marginBottom: 16
                }}
            >

                <Row gutter={[16, 16]}>

                    <Col
                        xs={24}
                        md={16}
                    >

                        <Input
                            prefix={<SearchOutlined />}
                            placeholder="Buscar por nombre, apellidos o dinámica..."
                            value={searchText}
                            onChange={(e) =>
                                setSearchText(
                                    e.target.value
                                )
                            }
                            allowClear
                        />

                    </Col>

                    <Col
                        xs={24}
                        md={8}
                    >

                        <Select
                            style={{
                                width: "100%"
                            }}
                            placeholder="Filtrar por género"
                            value={selectedGender}
                            onChange={setSelectedGender}
                            allowClear
                        >

                            {genderOptions.map(
                                (gender) => (

                                    <Option
                                        key={gender}
                                        value={gender}
                                    >
                                        {gender}
                                    </Option>

                                )
                            )}

                        </Select>

                    </Col>

                </Row>

            </Card>

            {/* ======================================================
          INFORMACIÓN DE SELECCIÓN
      ====================================================== */}

            {selectedRowKeys.length > 0 && (

                <Card
                    size="small"
                    style={{
                        marginBottom: 16
                    }}
                >

                    <Row
                        justify="space-between"
                        align="middle"
                    >

                        <Col>

                            <Text strong>
                                {selectedRowKeys.length}
                                {" "}
                                usuario(s) seleccionado(s)
                            </Text>

                        </Col>

                        <Col>

                            <Space>

                                <Button
                                    onClick={() =>
                                        setSelectedRowKeys([])
                                    }
                                >
                                    Limpiar selección
                                </Button>

                                <Button
                                    type="primary"
                                    icon={<GiftOutlined />}
                                    onClick={openBonusModal}
                                >
                                    Otorgar Bravos
                                </Button>

                            </Space>

                        </Col>

                    </Row>

                </Card>

            )}

            {/* ======================================================
          TABLA
      ====================================================== */}

            <Table

                rowSelection={rowSelection}

                rowKey="id"

                loading={loading}

                dataSource={filteredUsuarios}

                columns={columns}

                pagination={{
                    pageSize: 20,
                    showSizeChanger: true,
                    showTotal: (total) =>
                        `Total: ${total} usuarios`
                }}

                scroll={{
                    x: 900
                }}

            />

            {/* ======================================================
          MODAL EDITAR USUARIO
      ====================================================== */}

            <Modal

                title="Editar usuario"

                open={modalVisible}

                onCancel={() => {

                    setModalVisible(false);

                    form.resetFields();

                }}

                onOk={handleModalSubmit}

                okText="Guardar"

                cancelText="Cancelar"

            >

                <Form
                    form={form}
                    layout="vertical"
                >

                    <Form.Item
                        label="Nombre"
                        name="name"
                    >
                        <Input />
                    </Form.Item>

                    <Form.Item
                        label="Apellido paterno"
                        name="ape_pat"
                    >
                        <Input />
                    </Form.Item>

                    <Form.Item
                        label="Apellido materno"
                        name="ape_mat"
                    >
                        <Input />
                    </Form.Item>

                    <Form.Item
                        label="Dinámica"
                        name="dinamica"
                    >
                        <Input />
                    </Form.Item>

                    <Form.Item
                        label="Género"
                        name="gender"
                    >

                        <Select>

                            {genderOptions.map(
                                (gender) => (

                                    <Option
                                        key={gender}
                                        value={gender}
                                    >
                                        {gender}
                                    </Option>

                                )
                            )}

                        </Select>

                    </Form.Item>

                </Form>

            </Modal>

            {/* ======================================================
          MODAL BONIFICACIÓN
      ====================================================== */}

            <Modal

                title={
                    <Space>
                        <GiftOutlined />
                        <span>
                            Otorgar bonificación de Bravos
                        </span>
                    </Space>
                }

                open={bonusModalVisible}

                onCancel={() => {

                    if (!bonusLoading) {

                        setBonusModalVisible(false);

                        bonusForm.resetFields();

                    }

                }}

                onOk={handleBonusSubmit}

                okText="Otorgar Bravos"

                cancelText="Cancelar"

                confirmLoading={bonusLoading}

                destroyOnClose

            >

                <Card
                    size="small"
                    style={{
                        marginBottom: 20
                    }}
                >

                    <Space
                        direction="vertical"
                        size={2}
                    >

                        <Text type="secondary">
                            Usuarios seleccionados
                        </Text>

                        <Text
                            strong
                            style={{
                                fontSize: 22
                            }}
                        >
                            {selectedRowKeys.length}
                        </Text>

                    </Space>

                </Card>

                <Form

                    form={bonusForm}

                    layout="vertical"

                >

                    <Form.Item

                        label="Cantidad de Bravos"

                        name="points"

                        rules={[
                            {
                                required: true,
                                message:
                                    "Ingresa la cantidad de Bravos"
                            }
                        ]}

                    >

                        <InputNumber

                            min={1}

                            max={10000}

                            precision={0}

                            style={{
                                width: "100%"
                            }}

                            placeholder="Ej. 200"

                            addonBefore="⭐"

                        />

                    </Form.Item>

                </Form>

                <Text
                    type="secondary"
                    style={{
                        fontSize: 12
                    }}
                >
                    La bonificación se aplicará directamente
                    en el servidor y quedará registrada.
                </Text>

            </Modal>

            {/* ======================================================
          PREVIEW IMAGEN
      ====================================================== */}

            <Modal

                open={previewVisible}

                footer={null}

                onCancel={() =>
                    setPreviewVisible(false)
                }

            >

                <img
                    src={previewImage}
                    alt="Preview"
                    style={{
                        width: "100%"
                    }}
                />

            </Modal>

        </div>

    );

}